
<!DOCTYPE html>

<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css" rel="stylesheet">
  <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/js/bootstrap.bundle.min.js"></script>
  <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.0.8/css/all.css">
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
  <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css">
  
</head>







<div class="card" *ngIf="ShowCard===2">
  <div class="card-body">
<br>
    <div class="row">
      <p style="color: #6ab187;"><strong>EMPLOYEE SCREENING</strong></p>
      <div class="col-3"><img style="width: 37px;height: auto;" src="assets/users.png"><a style="text-decoration: none;color:black" routerLink="/whitecollar"> <strong class="white">&nbsp; White-collar verification</strong></a></div>
      <div class="col-3"><img style="width: 37px;height: auto;" src="assets/mechanic.png"><a style="text-decoration: none;color: black;"  routerLink="/bluecollar"><strong class="white"> Blue-collar verification</strong></a></div>
      <br><br>
      <div class="col-3"><img style="width: 37px;height: auto;" src="assets/online-business.png"><a style="text-decoration: none;color: black;" routerLink="/gigworker"> &nbsp;<strong class="white"> Gig Worker verification</strong></a></div>
    </div>
    <br>
    
    <div class="row">
      
      <p style="color: #6ab187;"><strong>RISK & COMPLIANCE</strong></p>
      <div class="col-3"><img style="width: 30px;height: auto;" src="assets/risktopicon.png"><a style="text-decoration: none;color: black;" routerLink="/riskmanage"><strong class="white"> Risk Management</strong></a></div>
      <div class="col-3"><img style="width: 35px;height: auto;" src="assets/onboarding.png"><a style="text-decoration: none;color: black;" routerLink="/vendor"><strong class="white" > Vendor Onboarding</strong></a></div>
      <div class="col-3"><img style="width: 40px;height: auto;" src="assets/distributortopicon.png"><a style="text-decoration: none;color: black;" routerLink="/distribute"><strong class="white"> Distributor onboarding</strong></a></div>
      <div class="col-3"><img style="width: 40px;height: auto;" src="assets/duediligence.jpg"><a style="text-decoration: none;color: black;" routerLink="/duediligence"><strong class="white"> Due Diligence</strong> </a></div>
    </div>
    <br>
  
    <!--  -->
    <div class="row">
      
      <p style="color: #6ab187;"><strong> FINANCIAL INTELLIGENCE</strong></p>
      <div class="col-3"><img style="width: 40px;height: auto;" src="assets/kycsolution.png"><a style="text-decoration: none;color: black;" routerLink="/kycsolution"><strong class="white"> KYC solutions</strong> </a></div>
    </div>
    <br>
  
  </div>
</div>


<div class="card" *ngIf="ShowCard===1">
  <div class="card-body">
<br>
<p style="color: #6ab187;font-weight: 600;"><strong>PRODUCT</strong></p>

    <div class="row">
      <div class="col"><a style="text-decoration: none;color: black;cursor: pointer;" (click)="ShowCard=3"><strong class="white"><img style="width: 4%;height: 100%;" src="assets/docverify.png"> Document Verification</strong> </a></div>
      <div class="col"><a style="text-decoration: none;color: black;cursor: pointer;" routerLink="/service"><strong class="white"><img style="width: 5%;height: 110%;" src="assets/docsignin.png"> Document SignIn</strong> </a></div>
  
    </div>
    <br>

    <div class="row">
       </div>
    <br>
    
  </div>
</div>


<!--  -->

<div class="card" *ngIf="ShowCard===3">
  <div class="card-body">
    <br>
<div class="row">
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/aadhartopicon.png"><a style="text-decoration: none;color: black;" routerLink="/aadhaar"> <strong class="white"> Aadhaar verification</strong></a></div>
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/pantopicon.png"><a style="text-decoration: none;color: black;"  routerLink="/pan"><strong class="white"> Pan verification</strong></a></div>
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/gsttopicon.jpg"><a style="text-decoration: none;color: black;" routerLink="/gst"><strong class="white"> Gst verification</strong></a></div>
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/drivinglicensetop.jpg"><a style="text-decoration: none;color: black;" routerLink="/driving"><strong class="white"> Driving verification</strong></a></div>
</div><br><br>

<div class="row">
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/passporttopicon.png"><a style="text-decoration: none;color: black;" routerLink="/passport"><strong class="white"> Passport verification</strong> </a></div>
  <div class="col"><img style="width: 58px;height: 44px;" src="assets/rcverify.png"><a style="text-decoration: none;color: black;" routerLink="/rcverify"><strong class="white"> RC verification</strong></a></div>
  <div class="col"><img style="width: 45px;height: 44px;" src="assets/msmeverify.png"><a style="text-decoration: none;color: black;" routerLink="/msmeverify"><strong class="white"> MSME verification</strong> </a></div>
  <div class="col"><img style="width: 45px;height: 44px;" src="assets/verification.png"><a style="text-decoration: none;color: black;" routerLink="/dinverify"><strong class="white"> DIN verification</strong></a></div>
</div>

<br><br>
<div class="row">
  <div class="col-3"><img style="width: 35px;height: 44px;border-radius: 20px;" src="assets/cinicon.png"><a style="text-decoration: none;color: black;" routerLink="/cinverify"><strong  class="white"> CIN verification</strong></a></div>
</div>
</div>
</div>



<br><br>
<br>

<div class="row" data-aos="zoom-in" data-aos-delay="300"   >
  <div class="col-md-6  text-center">
    <img style="width:70%;margin-top: 50px;" src="assets/pancardtop.png">
</div>
    <div style="padding-top: 10%;" class="col-md-6">
        <h1 style="color: #6ab187;">
           PAN card Verification
          </h1>
        <h5 >&nbsp;&nbsp;&nbsp;Verify the legitimacy of a PAN card prior to onboarding clients, staff, and other parties in order to stop fraud related to altered and counterfeit identification cards at the outset.</h5>
    </div>

    
</div>
<br><br>
<br><br>


  <div class="row" data-aos="zoom-in" data-aos-delay="300"   >
    <div class="col">
        <div style="
        margin: 0 auto;
        float: none;
        margin-bottom: 10px;
        background-color: #eff8ff;" class="card w-65">
        <div class="card-body">
            <h2 style="text-align: center;font-size: 550;color: #6ab187;">What do you require for PAN Card<br> Verification?</h2>
        </div>
        </div>
    </div>
    </div>
  

    <!-- card -->
    
<div class="row p-3" data-aos="fade-up" data-aos-delay="300"  >

    <div   class="col-md-4">
        <br>
        <img style="width: 60px;height: 65px;" src="assets/fakepan.png">
       <br><br><br>
        <h5 >Fake Pan Card threat</h5>
        <p style="align-items: center;">Your PAN card credentials could be<br> used by someone to open a bank account<br> in your name and use it to commit fraud. <br>This could lead to you being held accountable<br> for the scammer's deeds.</p>
    </div>
  
    <div class="col-md-4">
          <br>
          <img style="width: 70px;height: 80px;margin-top: 10px;" src="assets/frauddetect.png">
         <br><br>
          <h5 >Loan and credit card fraud</h5>
          <p style="align-items: center;">Your PAN card credentials could be used by <br>someone to open a bank account in your name<br> and use it to commit fraud. This could lead to you <br>being held accountable for the scammer's deeds.</p>
      </div>
     
      <div class="col-md-4">
     
        <br>
        <img style="width: 60px;height: 60px;margin-top: 4px;" src="assets/identitytheft.png">
       <br><br><br>
        <h5 >Identity theft</h5>
        <p style="align-items: center;">The PAN card credentials of victims can be stolen or used by scammers to open false bank accounts, carry out financial activities in their names, or assume the identity of the victim.<p>
    </div>

  </div>
  
  <br><br>
  <!-- api -->
  <br><br>

  <h1 data-aos="zoom-in" data-aos-delay="300"  style="text-align: center;color: #6ab187;">Types of PAN Verification API's​​</h1><br>
  <h6 data-aos="zoom-in" data-aos-delay="300"  style="text-align: center;color: gray;">Choose from different types of instant PAN API’s as per your Business requirement</h6>
  <br>
  <!-- verification api's -->
    <div style="background-color: azure;" class="row p-2">
      <div class="col-md-3 mt-2 "  data-aos="fade-up" data-aos-delay="300" >
          <div class="card" style="height: 260px;"   >
              <div class="card-body">
                  <img style="width: 25%;height:25%" src="assets/calendar.png">
                  <br><br>
                <h5 class="card-title">PAN - Verify Name and Date of Birth</h5>
                <p class="card-text">PAN Verification API to fetch card status along with other details like name and date of birth.</p>
                  
              </div>            
            </div>
      </div>
  
      <div class="col-md-3 mt-2 "  data-aos="fade-up" data-aos-delay="300" >
  
          <div class="card" style="height: 260px;"  >
              <div class="card-body">
                  <img style="width: 25%;height:25%" src="assets/validationcheck.png"><br>
                  <br>
                <h5 class="card-title">PAN Card Validation Check</h5>
                <p class="card-text">PAN Verification API to validate given information on PAN number and if it is valid or not.</p>
             <br>
              </div>            
            </div>
      </div>
  
      <div class="col-md-3 mt-2 "  data-aos="fade-up" data-aos-delay="300" >
  
          <div class="card" style="height: 260px;"  >
              <div class="card-body">
                  <img style="width: 25%;height:25%" src="assets/link.png">
                  <br><br>
                <h5 class="card-title">Verify PAN Aadhaar Link Status</h5>
                <p class="card-text">Check the seeding status ,whether the PAN Card is linked with the Aadhaar Card or Not.</p>
              </div>            
            </div>
      </div>
  
      <div class="col-md-3 mt-2 "  data-aos="fade-up" data-aos-delay="300" >
  
          <div class="card" style="height: 260px;"  >
              <div class="card-body">
                  <img style="width: 35%;height:34%" src="assets/ocr.png">
                    <h4 class="card-title">OCR Based PAN Card Verification</h4>
                <p class="card-text">Fetch all PAN Card details via Optical Character Recognition(OCR) technology.</p>
              </div>            
            </div>
      </div>
      
      <div class="col-md-3 mt-2 "  data-aos="fade-up" data-aos-delay="300" >
        <div class="card" style="height: 260px;"  >
            <div class="card-body">
                <img style="width: 25%;height:25%" src="assets/search.png">
                <br><br>
              <h5 class="card-title">e PAN Verification (Entity & Individual)</h5>
              <p class="card-text">e PAN Verification (Entity & Individual) to uncover PAN details from an e-PAN pdf via OCR
              </p>
            </div>            
          </div>
    </div>

    <div class="col-md-3 mt-2 "  data-aos="fade-up" data-aos-delay="300" >

        <div class="card" style="height: 260px;"  >
            <div class="card-body">
                <img style="width: 25%;height:25%" src="assets/check.png"><br>
                <br>
              <h5 class="card-title">PAN ITD Status Check</h5>
              <p class="card-text">Check Income Tax declaration status via PAN-ITD status check API</p>
           <br>
            </div>            
          </div>
    </div>

    <div class="col-md-3 mt-2 "  data-aos="fade-up" data-aos-delay="300" >

        <div class="card" style="height: 260px;"  >
            <div class="card-body">
                <img style="width: 25%;height:25%" src="assets/checkpan.png">
                <br><br>
              <h5 class="card-title">Advanced PAN Verification Check</h5>
              <p class="card-text">Advanced PAN Verification check to get complete PAN details from names to city codes.</p>
            </div>            
          </div>
    </div>

    <div class="col-md-3 mt-2 "  data-aos="fade-up" data-aos-delay="300" >

        <div class="card" style="height: 260px;" >
            <div class="card-body">
                <img style="width: 25%;height:29%;border-radius: 15px;" src="assets/namematchpan.png">
                <br><br>
                  <h5 class="card-title">PAN - Verify Name Match</h5>
              <p class="card-text">PAN Name Match Check if the given name is same as mentioned on PAN Card</p>
              <br>
            </div>            
          </div>
    </div>

    </div>

  
  
    
  
   
    

  

<!-- advantage -->


<div class="row" data-aos="zoom-in" data-aos-delay="300"  >
  <div class="col">
      <div style="
      margin: 0 auto;
      float: none;
      margin-bottom: 10px;" class="card w-65">
      <div class="card-body">
          <h2 style="text-align: center;font-size: 550;color: #6ab187;">FaCheck's PAN Verification API's Advantages</h2>
      </div>
      </div>
  </div>
  </div>
  <br><br><br>

   
<div class="row p-2">

  <div   class="col-md-3"  data-aos="fade-up" data-aos-delay="300"  >
      <br>
      <img style="width: 60px;height: 65px;background-color: #eff8ff;" src="assets/verify.png">
     <br><br><br>
      <h5 >Seamless Verification</h5>
      <p style="align-items: center;">Our API-led Verification assures seamless verification  as OCR automatically fetches the details from the documents – cutting the need for manual intervention and delay.</p>
  </div>

  <div style="background-color: #c9d9e6;" class="col-md-3"  data-aos="fade-up" data-aos-delay="300"  >
        <br>
        <img style="width: 70px;height: 80px;" src="assets/realtime.png">
       <br><br>
        <h5 >Real - Time Response</h5>
        <p style="align-items: center;">The details are retrieved in real-time and verified from government databases to reduce the risks associated with identity theft and fraudulent activities.</p>
    </div>
   
    <div  style="background-color: #eff8ff;" class="col-md-3"  data-aos="fade-up" data-aos-delay="300"  >
   
      <br>
      <img style="width: 60px;height: 60px;" src="assets/integrate.png">
     <br><br><br>
      <h5 >Easily Integrable</h5>
      <p style="align-items: center;">Our Industry-leading APIs ensure seamless integration with your existing workflows and processes.<p>
  </div>
  <div style="background-color: #c9d9e6;" class="col-md-3"  data-aos="fade-up" data-aos-delay="300"  >
   
    <br>
    <img style="width: 60px;height: 60px;" src="assets/dataprivacy.png">
   <br><br><br>
    <h5 >Data Privacy</h5>
    <p style="align-items: center;">The Details of every individual are safe in the API platform as it is completely automated and does not need any third party assistance. <p>
</div>


</div>


<br><br><br><br>


  <!-- faq -->
  <div class="faq-title text-center pb-3" data-aos="zoom-in" data-aos-delay="300"  >
    <h2>FAQ</h2>
</div>


<div class="row" data-aos="fade-up" data-aos-delay="300" >
  <div id="slide" style="margin-top: 10%;" class="col-md-6">
    <h1 style="color: #6ab187;text-align: center ;">FACheck's FAQ</h1>
   </div>

    <div class="col-md-6">
        <div style="width: 90%;" class="faq-content">
            <div class="faq-question">
              <input id="q1" type="checkbox" class="panel">
             
              <img style="width: 30px;height: 30px;margin-top: 13px;" class="plus" src="assets/handlogo.png">
              <label for="q1" class="panel-title"> &nbsp;&nbsp; What is the need of a PAN Verification API?</label>
              <div class="panel-content">Leveraging PAN verification API can make your onboarding process easier and frictionless for your clients, customers, vendors, and other third parties. Our configurable PAN verification API automates the process, enables businesses to conduct verifications in bulk, and eliminates the need to invest a good amount of man-hours into the process.</div>
            </div>
            
            <div class="faq-question">
              <input id="q2" type="checkbox" class="panel">
              <img style="width: 30px;height: 30px;margin-top: 13px;" class="plus" src="assets/handlogo.png">
              <label for="q2" class="panel-title">&nbsp;&nbsp; How does PAN Verification API work? </label>
              <div class="panel-content">This easy-to-follow process includes uploading the PAN details through API and extracting data in real-time through OCR that gets validated from the Government databases.</div>
            </div>
            
            <div class="faq-question">
              <input id="q3" type="checkbox" class="panel">
              <img style="width: 30px;height: 30px;margin-top: 13px;" class="plus" src="assets/handlogo.png">
              <label for="q3" class="panel-title">&nbsp;&nbsp; How much time does the verification take? </label>
              <div class="panel-content">AuthBridge PAN verification API instantly fetches the information provided on the PAN card and verifies the data in real-time from government databases.</div>
            </div>
        
            <div class="faq-question">
                <input id="q4" type="checkbox" class="panel">
                
               <img style="width: 30px;height: 30px;margin-top: 13px;" class="plus" src="assets/handlogo.png">
                <label for="q4" class="panel-title">&nbsp;&nbsp; How does PAN Verification API helpful to different industries? </label>
                <div class="panel-content">It empowers businesses and other institutions where officials/third parties cannot commute for in-person PAN verification. Some of the top sectors like BFSI, Retail, FMCG, Pharmaceutical, and many more can leverage Facheck integrated API technology to onboard more customers, clients, and vendors with instant PAN verification.</div>
              </div>
              
          </div>
    </div>

   

</div>

  


 






